import { useConfig } from '../providers/ConfigProvider';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useUserEmail } from './use-user.hooks';
import { useOnce } from './use-utils.hooks';
import { initClientSentry } from '../helpers/sentry.helpers';

/**
 * Initialize Sentry once for this page, and attach the signed-in user.
 * Only enable Sentry on test and production.
 */
export const useInitSentry = () => {
  const [config] = useConfig();
  const email = useUserEmail();

  useOnce(() => {
    initClientSentry({
      environment: config.environment,
      release: config.version,
    });
  });

  useEffect(() => {
    if (!email) return;
    Sentry.setUser({ email });
    Sentry.addBreadcrumb({
      category: 'user',
      level: 'info',
      message: 'user_email',
      data: { email },
    });
  }, [email]);
};
